module.exports = __webpack_public_path__ + "img/close.7b65c2f3.svg";